// lib
import React from 'react';
import clsx from 'clsx';

// mui
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { Box, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	container: {
		position: 'relative',
	},
	subText: {
		fontSize: 'small',
		position: 'absolute',
		right: '0',
	},
	icon: {
		borderRadius: '50%',
		color: 'rgb(255, 200, 69)',
		borderColor: 'white',
		backgroundColor: 'rgba(255, 200, 69, 0.1)',
		height: '70px',
		width: '70px',
		textAlign: 'center',
		paddingTop: '18px',
	},
	img: {
		border: '1px solid red',
	},
	orange: {
		backgroundColor: 'rgba(255, 200, 69, 0.1)',
	},
	white: {
		backgroundColor: '#FFFFFF',
	},
	blue: {
		backgroundColor: 'rgba(5, 195, 221, 0.1)',
	},
	green: {
		backgroundColor: 'rgba(151, 215, 0, 0.1)',
	},
	img: {
		borderRadius: '50%',
		color: 'rgb(255, 200, 69)',
		height: '70px',
		width: '70px',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
}));

export default function CustomCard(props) {
	const classes = useStyles();

	const graphic = clsx({
		[classes.icon]: props.icon,
		[classes.blue]: props.iconColor === 'blue',
		[classes.green]: props.iconColor === 'green',
		[classes.orange]: props.iconColor === 'orange',
		[classes.white]: props.iconColor === 'white',
		[classes.img]: props.img,
	});

	return (
		<Card variant='outlined'>
			<CardContent>
				<Box className={classes.container}>
					{props.subtext && <Box className={classes.subText}>{props.subtext}</Box>}
					{props.icon && <Box className={graphic}>{props.icon}</Box>}
					{props.img && <Box className={graphic}>{props.img}</Box>}
				</Box>
				<br />
				<Box className={classes.content}>{props.children}</Box>
			</CardContent>
		</Card>
	);
}
